const API_CONFIG = {
    baseUrl: `${document.documentElement.getAttribute( 'data-api' )}`,
    timeout: 100000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
}

export default API_CONFIG